$(document).ready(function () {
	$('[data-wc-readmore]').each(function () {
		let cheight = $(this).data('wc-readmore-height') || 250
		let targetEl = $(this)

		if (!$(this).parent().hasClass('section-image-full-width')) {
			// Has a floating image
			targetEl = $(this).parent()

			// Moving .article-disclaimers outside readmore
			let disclaimer = $(this).parent().find('.article-disclaimers')
			$(this).parent().after(disclaimer)
			disclaimer.addClass('article-disclaimers-padding')
		}

		targetEl.readmore({
			collapsedHeight: cheight,
			moreLink: `<a href="#">
				<span>${mL('leggi tutto')}</span>
				<span class="material-icons">keyboard_arrow_down</span>
			</a>`,
			lessLink: `<a href="#">
				<span class="material-icons">keyboard_arrow_up</span>
				<span>${mL('comprimi')}</span>
			</a>`,
			// lessLink: '',
		})
	})

	function mL(string) {
		const data = {
			'leggi tutto': {
				it: 'Leggi tutto',
				en: 'Read more',
				de: 'Weiterlesen',
			},
			'comprimi': {
				it: 'Comprimi',
				en: 'Collapse',
				de: 'Zusammenbruch',
			},
		}

		return data[string][WC.lang.substr(0, 2)]
	}
})
